// extracted by mini-css-extract-plugin
export default {"labels":"ePEk9k","label":"eqFXt1","small":"riky4s"};